import { useState, useEffect, useCallback, useRef } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Input,
  Button,
  Label,
  Card,
} from "reactstrap";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { post, put, get } from "../../api/axios";
import endpoints from "../../api/endpoints";
import avatar from "../../assets/images/nav4.svg";
import {
  useNavigate,
  useParams,
  useLocation,
  json,
  Link,
} from "react-router-dom";
import { toast, Bounce } from "react-toastify";
import imgupload from "../../assets/images/imageupload.svg";
import newImgIcon from "../../assets/images/Plus.png";
import Autocomplete from "react-google-autocomplete";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import debounce from "lodash.debounce";
import Select from "react-select";
import { useSelector } from "react-redux";

const AddBusinessVerification = () => {
  const [isUpdate, setIsUpdate] = useState(false);
  {
    isUpdate
      ? (document.title =
          "Edit Business Verification | Elevated - Admin Dashboard")
      : (document.title =
          "Add Business Verification | Elevated - Admin Dashboard");
  }
  const { id } = useParams();
  const navigate = useNavigate();
  const location1 = useLocation();
  const [gymData, setGymData] = useState(null);
  const [mediaFiles, setMediaFiles] = useState({ files: [null] });
  const [equipment, setEquipment] = useState([]);
  const [logoFiles, setLogoFiles] = useState(null);
  const [verificationDocument, setVerificationDocument] = useState(null);
  const [accountStatement, setAccountStatement] = useState(null);
  const [bankLetter, setBankLetter] = useState(null);
  const [apiError, setApiError] = useState("");
  const [formError, setFormError] = useState("");
  const [logoError, setLogoError] = useState("");
  const [clickCount, setClickCount] = useState(0);
  const [showAddButton, setShowAddButton] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [amenity, setAmenity] = useState([]);
  const verifyFileInputRef = useRef(null);
  const statementFileInputRef = useRef(null);
  const letterFileInputRef = useRef(null);
  const gymId = location1.state?.gymId;

  const [initialValues, setInitialValues] = useState({
    companyTaxId: "",
    companyVerificationDocument: [],
    companyAddressCity: "",
    companyAddressLine1: "",
    companyAddressPostalCode: "",
    companyAddressState: "",
    stateIssuedIDCard: "",
    // tosAcceptanceDate: "",
    // tosAcceptanceIp: "",
    // externalAccount: "",
    // passport: "",
    // passportCard: "",
    // driverLicense: "",
    // residentPermitID: "",
    // borderCrossingCard: "",
    // childIDCard: "",
    // nycCard: "",
    // acceptableFormsOfBankAc: "",
    // bankAccountStatement: [],
    // bankLetter: [],
    // check: "",
    // accountHolderName: "",
    // bankAccountNumber: "",
  });
  const validationSchema = Yup.object().shape({
    companyTaxId: Yup.string().required("Please provide Company Tax Id."),
    companyVerificationDocument: Yup.mixed().required(
      "Company verification document is required."
    ),
    stateIssuedIDCard: Yup.string().required(
      "Please provide state issued Id card."
    ),

    companyAddressCity: Yup.string().required(
      "Please provide company address city."
    ),
    companyAddressLine1: Yup.string().required(
      "Please provide company address."
    ),
    companyAddressPostalCode: Yup.string().required(
      "Please provide company address postal code."
    ),
    companyAddressState: Yup.string().required(
      "Please provide company address state."
    ), // tosAcceptanceDate: Yup.string().required("Please provide acceptance date."),
    // tosAcceptanceIp: Yup.string().required("Please provide acceptance Ip."),
    // externalAccount: Yup.string().required("Please provide external account."),
    // passport: Yup.string().required("Please provide Passport"),
    // passportCard: Yup.string().required("Please provide Passcort Card"),
    // driverLicense: Yup.string().required("Please provide driving License"),
    // residentPermitID: Yup.string().required(
    //   "Please provide resident permir card."
    // ),
    // borderCrossingCard: Yup.string().required(
    //   "Please provide border crossing card."
    // ),
    // childIDCard: Yup.string().required("Please provide child Id card."),
    // nycCard: Yup.string().required("Please provide NYC card."),
    // acceptableFormsOfBankAc: Yup.string().required(
    //   "Please provide acceptable forms of bank."
    // ),
    // bankAccountStatement: Yup.mixed().required("Bank Statement is required."),
    // bankLetter: Yup.mixed().required("Bank Letter is required."),
    // check: Yup.string().required("Please provide check."),
    // accountHolderName: Yup.string().required(
    //   "Please provide account holder name."
    // ),
    // bankAccountNumber: Yup.string().required(
    //   "Please provide bank account number."
    // ),
  });
  const handleSubmit = async (values, id) => {
    const formData = new FormData();
    formData.append("companyTaxId", values.companyTaxId);
    formData.append(
      "companyVerificationDocument",
      values.companyVerificationDocument
    );

    formData.append("companyAddressCity", values.companyAddressCity);
    formData.append("companyAddressLine1", values.companyAddressLine1);
    formData.append(
      "companyAddressPostalCode",
      values.companyAddressPostalCode
    );
    formData.append("companyAddressState", values.companyAddressState);
    formData.append("stateIssuedIDCard", values.stateIssuedIDCard);
    // formData.append("tosAcceptanceDate", values.tosAcceptanceDate);
    // formData.append("tosAcceptanceIp", values.tosAcceptanceIp);
    // formData.append("externalAccount", values.externalAccount);
    // formData.append("passportCard", values.passportCard);
    // formData.append("driverLicense", values.driverLicense);
    // formData.append("residentPermitID", values.residentPermitID);
    // formData.append("borderCrossingCard", values.borderCrossingCard);
    // formData.append("childIDCard", values.childIDCard);
    // formData.append("nycCard", values.nycCard);
    // formData.append("acceptableFormsOfBankAc", values.acceptableFormsOfBankAc);
    // formData.append("check", values.check);
    // formData.append("accountHolderName", values.accountHolderName);
    // formData.append("bankAccountNumber", values.bankAccountNumber);
    // formData.append("passport", values.passport);
    // formData.append("bankAccountStatement", values.bankAccountStatement);
    // formData.append("bankLetter", values.bankLetter);
    try {
      setIsSubmitting(true);

      if (isUpdate) {
        const gymResponse = await put(
          `${endpoints.business}/${gymId}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (gymResponse?.data?.success) {
          toast.success("Business Verification Details Added Successfully", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
          navigate("/list-gyms");
        } else if (gymResponse?.response?.data) {
          toast.error(gymResponse?.response?.data?.message, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else {
          toast.error("Gym Added Failed", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        }
      } else {
      }
    } catch (error) {
      console.log(error, "asdfasdf", error.message);
      setApiError("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const cancel = () => {
    navigate("/dashboard");
  };
  const { appRole } = useSelector((state) => state.auth.currentUser);

  const fetchDetails = async (id) => {
    try {
      const response = await get(`${endpoints.gym}/${gymId}`);
      if (response?.data?.success) {
        setGymData(response?.data?.data);
        let tempData = response?.data?.data;

        setIsUpdate(true);
        setInitialValues({
          companyTaxId: tempData?.companyTaxId,
          companyVerificationDocument:
            tempData?.companyVerificationDocument?.data || [],
          companyAddressCity: tempData?.companyAddressCity || "",
          companyAddressLine1: tempData?.companyAddressLine1 || "",
          companyAddressPostalCode: tempData?.companyAddressPostalCode || "",
          companyAddressState: tempData?.companyAddressState || "",
          stateIssuedIDCard: tempData?.stateIssuedIDCard || "",
          // externalAccount: tempData?.externalAccount || "",
          // passport: tempData?.passport || "",
          // passportCard: tempData?.passportCard || "",
          // driverLicense: tempData?.driverLicense || "",
          // residentPermitID: tempData?.residentPermitID || "",
          // borderCrossingCard: tempData?.borderCrossingCard || "",
          // childIDCard: tempData?.childIDCard || "",
          // nycCard: tempData?.nycCard || "",
          // acceptableFormsOfBankAc: tempData?.acceptableFormsOfBankAc || "",
          // bankAccountStatement: tempData?.bankAccountStatement?.data || [],
          // bankLetter: tempData?.bankLetter?.data || [],
          // check: tempData?.check || "",
          // accountHolderName: tempData?.accountHolderName || "",
          // bankAccountNumber: tempData?.bankAccountNumber || "",
          // tosAcceptanceDate: tempData?.tosAcceptanceDate || "",
          // tosAcceptanceIp: tempData?.tosAcceptanceIp || "",
        });
      }
    } catch (error) {
      console.error("Error fetching terms details:", error);
      toast.error("Failed to fetch terms details. Please try again.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    }
  };
  useEffect(() => {
    fetchDetails();
  }, []);
  return (
    <div className=" mb-5 ">
      <Container fluid>
        <Row className="g-0">
          <Col>
            <Card className="rounded-4">
              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
                enableReinitialize
              >
                {({
                  errors,
                  values,
                  touched,
                  resetForm,
                  setFieldValue,
                  handleChange,
                  handleBlur,
                }) => (
                  <Form className="p-4">
                    <h3 className="ff-sora font-size-20 fw-bold primary-black ">
                      {isUpdate
                        ? "Edit Business Verification"
                        : "Add Business Verification"}
                    </h3>

                    {/* Company Verification Document*/}
                    <FormGroup>
                      <Label className="ff-sora font-size-16 fw-normal secondary-black">
                        Company Verification Document
                      </Label>
                      <div
                        className="cursor-pointer overflow-hidden position-relative ff-sora font-size-16 fw-normal secondary-black rounded-5 bg-light d-flex flex-column justify-content-center align-items-center"
                        style={{
                          border: "1px dashed #ccc",
                          width: "160px",
                          height: "160px",
                        }}
                      >
                        {values?.companyVerificationDocument instanceof File ? (
                          <div className="position-relative w-100 h-100">
                            <img
                              src={URL.createObjectURL(
                                values?.companyVerificationDocument
                              )}
                              alt="Upload"
                              className="h-100 w-100 object-fit-cover"
                            />

                            <button
                              type="button"
                              className="rounded-5 position-absolute cursor-pointer font-size-12"
                              style={{
                                color: "black",
                                zIndex: 1,
                                top: 10,
                                right: 15,
                              }}
                              onClick={() => {
                                setFieldValue(
                                  `companyVerificationDocument`,
                                  null
                                );
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ) : typeof values?.companyVerificationDocument ==
                          "string" ? (
                          <div className="position-relative w-100 h-100">
                            <img
                              src={`${process.env.REACT_APP_IMG_URL}${values?.companyVerificationDocument}`}
                              alt="Upload"
                              className="h-100 w-100 object-fit-cover"
                            />

                            <button
                              type="button"
                              className="rounded-5 position-absolute cursor-pointer font-size-12"
                              style={{
                                color: "black",
                                zIndex: 1,
                                top: 10,
                                right: 15,
                              }}
                              onClick={() => {
                                setFieldValue(
                                  `companyVerificationDocument`,
                                  null
                                );
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ) : (
                          <>
                            <img
                              src={imgupload}
                              alt="Upload"
                              height="40px"
                              width="40px"
                            />
                            <div className="secondary-black text-center mt-2 ff-sora font-size-16 fw-normal cursor-pointer">
                              Upload Media
                            </div>
                          </>
                        )}

                        <input
                          type="file"
                          accept="image/*"
                          className="position-absolute top-0"
                          style={{
                            width: "100%",
                            height: "100%",
                            opacity: 0,
                          }}
                          onChange={(e) => {
                            setFieldValue(
                              `companyVerificationDocument`,
                              e.target.files[0]
                            );
                          }}
                        />
                      </div>
                      <ErrorMessage
                        name={`companyVerificationDocument`}
                        component="div"
                        className="text-danger font-size-12 ff-sora fw-normal my-1"
                      />
                    </FormGroup>
                    {/* Company Tax Id */}
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      General Info
                    </h5>
                    <Row form>
                      <Col md={6}>
                        <FormGroup>
                          <Input
                            type="text"
                            name="companyTaxId"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Company Tax Id"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.companyTaxId}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`companyTaxId`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        {/* State Issue ID Card*/}
                        <FormGroup>
                          <Input
                            type="text"
                            name="stateIssuedIDCard"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="State Issue Id Card"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.stateIssuedIDCard}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`stateIssuedIDCard`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row form>
                      <Col md={6}>
                        {/* Company Address City */}
                        <FormGroup>
                          <Input
                            type="text"
                            name="companyAddressCity"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Company Address City"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.companyAddressCity}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`companyAddressCity`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        {/* Company Addres Line */}
                        <FormGroup>
                          <Input
                            type="text"
                            name="companyAddressLine1"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Company Address Line"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.companyAddressLine1}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`companyAddressLine1`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        {/* Company Addres Postal Code */}
                        <FormGroup>
                          <Input
                            type="text"
                            name="companyAddressPostalCode"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Company Address Postal Code"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.companyAddressPostalCode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`companyAddressPostalCode`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        {/* Company Address State*/}
                        <FormGroup>
                          <Input
                            type="text"
                            name="companyAddressState"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Company Address State"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.companyAddressState}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`companyAddressState`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* <Row form>
                     
                      <Col md={4}>
                   
                        <FormGroup>
                          <Input
                            type="text"
                            name="residentPermitID"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Resident Permit Id"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.residentPermitID}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`residentPermitID`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                     
                        <FormGroup>
                          <Input
                            type="text"
                            name="borderCrossingCard"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Border Crossing Card"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.borderCrossingCard}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`borderCrossingCard`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col> 
                    </Row>
                  
                    <Row form>
                      <Col md={6}>
             
                        <FormGroup>
                          <Input
                            type="text"
                            name="tosAcceptanceDate"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Acceptance Date"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.tosAcceptanceDate}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`tosAcceptanceDate`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                       
                        <FormGroup>
                          <Input
                            type="text"
                            name="tosAcceptanceIp"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Acceptance Ip"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.tosAcceptanceIp}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`tosAcceptanceIp`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    
                    <Row form>
                      <Col md={4}>
                  
                        <FormGroup>
                          <Input
                            type="text"
                            name="externalAccount"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="External Account"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.externalAccount}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`externalAccount`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                    
                        <FormGroup>
                          <Input
                            type="text"
                            name="passportCard"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Passport Card"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.passportCard}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`passportCard`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
               
                        <FormGroup>
                          <Input
                            type="text"
                            name="driverLicense"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Driver License"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.driverLicense}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`driverLicense`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  
                    <Row form>
                      <Col md={4}>
                   
                        <FormGroup>
                          <Input
                            type="text"
                            name="childIDCard"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Child Id Card"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.childIDCard}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`childIDCard`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                  
                        <FormGroup>
                          <Input
                            type="text"
                            name="nycCard"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="NYC Card"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.nycCard}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`nycCard`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                      
                        <FormGroup>
                          <Input
                            type="text"
                            name="acceptableFormsOfBankAc"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Acceptable Forms of Bank Account"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.acceptableFormsOfBankAc}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`acceptableFormsOfBankAc`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row form>
                      <Col md={6}>
                      
                        <FormGroup>
                          <Label className="ff-sora font-size-16 fw-normal secondary-black">
                            Bank Account Statement
                          </Label>
                          <div
                            className="cursor-pointer overflow-hidden position-relative ff-sora font-size-16 fw-normal secondary-black rounded-5 bg-light d-flex flex-column justify-content-center align-items-center"
                            style={{
                              border: "1px dashed #ccc",
                              width: "160px",
                              height: "160px",
                            }}
                          >
                            {values?.bankAccountStatement instanceof File ? (
                              <div className="position-relative w-100 h-100">
                                <img
                                  src={URL.createObjectURL(
                                    values?.bankAccountStatement
                                  )}
                                  alt="Upload"
                                  className="h-100 w-100 object-fit-cover"
                                />

                                <button
                                  type="button"
                                  className="rounded-5 position-absolute cursor-pointer font-size-12"
                                  style={{
                                    color: "black",
                                    zIndex: 1,
                                    top: 10,
                                    right: 15,
                                  }}
                                  onClick={() => {
                                    setFieldValue(`bankAccountStatement`, null);
                                  }}
                                >
                                  ×
                                </button>
                              </div>
                            ) : typeof values?.bankAccountStatement ==
                              "string" ? (
                              <div className="position-relative w-100 h-100">
                                <img
                                  src={`${process.env.REACT_APP_IMG_URL}${values?.bankAccountStatement}`}
                                  alt="Upload"
                                  className="h-100 w-100 object-fit-cover"
                                />

                                <button
                                  type="button"
                                  className="rounded-5 position-absolute cursor-pointer font-size-12"
                                  style={{
                                    color: "black",
                                    zIndex: 1,
                                    top: 10,
                                    right: 15,
                                  }}
                                  onClick={() => {
                                    setFieldValue(`bankAccountStatement`, null);
                                  }}
                                >
                                  ×
                                </button>
                              </div>
                            ) : (
                              <>
                                <img
                                  src={imgupload}
                                  alt="Upload"
                                  height="40px"
                                  width="40px"
                                />
                                <div className="secondary-black text-center mt-2 ff-sora font-size-16 fw-normal cursor-pointer">
                                  Upload Media
                                </div>
                              </>
                            )}

                            <input
                              type="file"
                              accept="image/*"
                              className="position-absolute top-0"
                              style={{
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                              }}
                              onChange={(e) => {
                                setFieldValue(
                                  `bankAccountStatement`,
                                  e.target.files[0]
                                );
                              }}
                            />
                          </div>
                          <ErrorMessage
                            name={`bankAccountStatement`}
                            component="div"
                            className="text-danger"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                
                        <FormGroup>
                          <Label className="ff-sora font-size-16 fw-normal secondary-black">
                            Bank Letter
                          </Label>
                          <div
                            className="cursor-pointer overflow-hidden position-relative ff-sora font-size-16 fw-normal secondary-black rounded-5 bg-light d-flex flex-column justify-content-center align-items-center"
                            style={{
                              border: "1px dashed #ccc",
                              width: "160px",
                              height: "160px",
                            }}
                          >
                            {values?.bankLetter instanceof File ? (
                              <div className="position-relative w-100 h-100">
                                <img
                                  src={URL.createObjectURL(values?.bankLetter)}
                                  alt="Upload"
                                  className="h-100 w-100 object-fit-cover"
                                />

                                <button
                                  type="button"
                                  className="rounded-5 position-absolute cursor-pointer font-size-12"
                                  style={{
                                    color: "black",
                                    zIndex: 1,
                                    top: 10,
                                    right: 15,
                                  }}
                                  onClick={() => {
                                    setFieldValue(`bankLetter`, null);
                                  }}
                                >
                                  ×
                                </button>
                              </div>
                            ) : typeof values?.bankLetter == "string" ? (
                              <div className="position-relative w-100 h-100">
                                <img
                                  src={`${process.env.REACT_APP_IMG_URL}${values?.bankLetter}`}
                                  alt="Upload"
                                  className="h-100 w-100 object-fit-cover"
                                />

                                <button
                                  type="button"
                                  className="rounded-5 position-absolute cursor-pointer font-size-12"
                                  style={{
                                    color: "black",
                                    zIndex: 1,
                                    top: 10,
                                    right: 15,
                                  }}
                                  onClick={() => {
                                    setFieldValue(`bankLetter`, null);
                                  }}
                                >
                                  ×
                                </button>
                              </div>
                            ) : (
                              <>
                                <img
                                  src={imgupload}
                                  alt="Upload"
                                  height="40px"
                                  width="40px"
                                />
                                <div className="secondary-black text-center mt-2 ff-sora font-size-16 fw-normal cursor-pointer">
                                  Upload Media
                                </div>
                              </>
                            )}

                            <input
                              type="file"
                              accept="image/*"
                              className="position-absolute top-0"
                              style={{
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                              }}
                              onChange={(e) => {
                                setFieldValue(`bankLetter`, e.target.files[0]);
                              }}
                            />
                          </div>
                          <ErrorMessage
                            name={`bankLetter`}
                            component="div"
                            className="text-danger"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row form>
                      <Col md={6}>
                    
                        <FormGroup>
                          <Input
                            type="text"
                            name="check"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Check"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.check}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`check`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                      
                        <FormGroup>
                          <Input
                            type="text"
                            name="accountHolderName"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Account Holder Name"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.accountHolderName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`accountHolderName`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row form>
                      <Col md={6}>
                
                        <FormGroup>
                          <Input
                            type="text"
                            name="bankAccountNumber"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Account Number"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values.bankAccountNumber}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`bankAccountNumber`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                      
                        <FormGroup>
                          <Input
                            type="text"
                            name="passport"
                            style={{
                              height: "56px",
                              border: "none",
                            }}
                            placeholder="Passport"
                            className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                            value={values?.passport}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name={`passport`}
                            component="div"
                            className="text-danger font-size-12 ff-sora fw-normal my-1"
                          />
                        </FormGroup>
                      </Col>
                    </Row>*/}
                    <div className="d-flex float-end">
                      <Button
                        type="submit"
                        className="me-2 rounded-pill"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          isUpdate ? (
                            <span>Updating...</span>
                          ) : (
                            <span>Adding...</span>
                          )
                        ) : isUpdate ? (
                          "Update"
                        ) : (
                          "Add"
                        )}
                      </Button>
                      <Button
                        color="white"
                        className="rounded-pill1"
                        onClick={cancel}
                      >
                        Cancel
                      </Button>
                    </div>
                    {apiError && (
                      <div className="text-danger mt-2">{apiError}</div>
                    )}
                  </Form>
                )}
              </Formik>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AddBusinessVerification;
